import { render, staticRenderFns } from "./ProtectedBagAccount.vue?vue&type=template&id=2e582301&scoped=true"
import script from "./ProtectedBagAccount.vue?vue&type=script&lang=js"
export * from "./ProtectedBagAccount.vue?vue&type=script&lang=js"
import style0 from "./ProtectedBagAccount.vue?vue&type=style&index=0&id=2e582301&prod&lang=scss"
import style1 from "./ProtectedBagAccount.vue?vue&type=style&index=1&id=2e582301&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e582301",
  null
  
)

export default component.exports